import { render, staticRenderFns } from "./salesDeed.vue?vue&type=template&id=9a578ffe"
import script from "./salesDeed.vue?vue&type=script&lang=js"
export * from "./salesDeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports